import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[onFocus]',
})
export class OnFocusDirective {
    private el: ElementRef;
    @Input('onFocus') focusClass: string;
    @Input() onFocusClass: string;

    constructor(private elementRef: ElementRef, public renderer: Renderer2) {
        this.el = this.elementRef;
    }

    @HostListener('focus', ['$event']) onFocus(e: Event) {
        let elRef = this.elementRef.nativeElement.parentElement;
        while (elRef != null) {
            if(elRef.classList.contains(this.onFocusClass))
                break;

            elRef = elRef.parentElement;
        }

        if(elRef != null)
            this.renderer.addClass(elRef, this.focusClass);
        return;
    }

    @HostListener('blur', ['$event']) onBlur(e: Event) {
        let elRef = this.elementRef.nativeElement.parentElement;
        while (elRef != null) {
            if(elRef.classList.contains(this.onFocusClass))
                break;

            elRef = elRef.parentElement;
        }

        if(elRef != null)
            this.renderer.removeClass(elRef, this.focusClass);
        return;
    }
}


// WEBPACK FOOTER //
// ./app/common/directives/onFocus.ts